import { onUnmounted } from 'vue';
import { debounce } from 'radash';
import { useStoreCommon } from '../store/common';
export const useWindowResize = (cb: () => void, delay: number = 100) => {
    let currentScreenWidth = window.document.documentElement.clientWidth;
    let currentScreenHeight = window.document.documentElement.clientHeight;
    const onWindowResize = debounce({ delay, }, () => {
        if (window.document.documentElement.clientWidth !== currentScreenWidth) {
            currentScreenWidth = window.document.documentElement.clientWidth;
            cb();
        } else {
            // 侧面板打开时，宽度没变也需要判断高度
            const storeCommon = useStoreCommon();
            if (storeCommon.inSidePanel && window.document.documentElement.clientHeight !== currentScreenHeight) {
                currentScreenHeight = window.document.documentElement.clientHeight;
                cb();
            }
        }
    });
    window.addEventListener('resize', onWindowResize);
    onUnmounted(() => {
        window.removeEventListener('resize', onWindowResize);
    });
};
